<template>
  <div class="containerIndex">
    <!-- header -->
    <div id="topPart">
      <div class="top wrap">
        <!-- 头部商标 + 搜索 -->
        <div class="topLogoMain">
          <div class="topLogoMainLeft">
            <a href="/"><img :src="logo" /></a>
            <!-- <a href="/"><div></div></a> -->
          </div>
          <div class="topLogoMainRight">
            <div class="header_search">
              <div>
                <el-input
                  v-model="searchValue"
                  placeholder="请输入标题"
                  style="width: 350px"
                ></el-input>
                <el-button type="submit" @click="searchSubmit">搜索</el-button>
              </div>
            </div>
          </div>
        </div>
        <!-- 导航菜单 -->
        <div class="topMenu">
          <div class="nav_box wrap">
            <ul class="nav_box_list clearfloat">
              <li style="border-left: none">
                <div class="nav_grop">
                  <h2><router-link to="/">网站首页</router-link></h2>
                </div>
              </li>
              <li
                v-for="(item, index) in navList"
                :key="index"
                :class="{ borderR: index == navList.length - 1 }"
                @mouseenter="navShow(item.channelId)"
                @mouseleave="navClose()"
              >
                <div class="nav_grop">
                  <!-- 一级菜单 -->
                  <h2>
                    <!-- 有二级URL则跳转 -->
                    <a
                      v-if="
                        item.child.length &&
                        item.child[0].url &&
                        item.child[0].url !== ''
                      "
                      target="_blank"
                      :href="item.child[0].url"
                    >
                      {{ item.name }}
                    </a>
                    <!-- 有二级，无URL，跳本地 -->
                    <a
                      v-if="
                        item.child.length &&
                        (!item.child[0].url || item.child[0].url == '')
                      "
                      :href="
                        item.catalog == 1
                          ? `/listPage/${item.child[0].entTChannelUuid}`
                          : item.catalog == 2
                          ? `/list/${item.child[0].entTChannelUuid}`
                          : `/list/${item.child[0].entTChannelUuid}`
                      "
                    >
                      {{ item.name }}
                    </a>
                    <!-- 无二级，直接跳本地 -->
                    <a
                      v-if="!item.child.length"
                      :href="
                        item.catalog == 1
                          ? `/listPage/${item.entTChannelUuid}`
                          : item.catalog == 2
                          ? `/list/${item.entTChannelUuid}`
                          : `/list/${item.entTChannelUuid}`
                      "
                    >
                      {{ item.name }}
                    </a>
                  </h2>
                  <el-collapse-transition>
                    <!-- 下拉菜单 -->
                    <div class="nav_down" v-show="navDown == item.channelId">
                      <div
                        class="wrap nav_down_wrap clearfloat"
                        v-show="item.child.length != 0"
                      >
                        <p v-for="(item1, index1) in item.child" :key="index1">
                          <!-- 无三级，无URL，跳本地 -->
                          <!-- <a v-if="!item1.child.length && (!item1.url || item1.url == '') && item1.entTChannelUuid !=='00190007'" -->
                          <a
                            v-if="
                              !item1.child.length &&
                              (!item1.url || item1.url == '') &&
                              item1.entTChannelUuid !== '02320005' &&
                              item1.entTChannelUuid !== '02310007' &&
                              item1.entTChannelUuid !== '02310006'
                            "
                            :href="
                              item1.catalog == 1
                                ? `/listPage/${item1.entTChannelUuid}`
                                : item1.catalog == 2
                                ? `/list/${item1.entTChannelUuid}`
                                : `/list/${item1.entTChannelUuid}`
                            "
                            target="_blank"
                          >
                            {{ item1.name }}
                          </a>
                          <!-- 无三级，跳URL -->
                          <!-- <a v-if="!item1.child.length && (item1.url && item1.url !== '') && item1.entTChannelUuid !=='00190007'" -->
                          <a
                            v-if="
                              !item1.child.length &&
                              item1.url &&
                              item1.url !== '' &&
                              item1.entTChannelUuid !== '02320005' &&
                              item1.entTChannelUuid !== '02310007' &&
                              item1.entTChannelUuid !== '02310006'
                            "
                            :href="item1.url"
                            target="_blank"
                          >
                            {{ item1.name }}
                          </a>
                          <!-- 特殊情况，无三级，为电视新闻，跳转建投的电视新闻 -->
                          <a
                            v-if="
                              !item1.child.length &&
                              item1.entTChannelUuid == '02310007'
                            "
                            href="http://www.gsjtw.cc/pressCenter/00190010"
                            target="_blank"
                          >
                            {{ item1.name }}
                          </a>
                          <!-- 特殊情况，无三级，为甘肃建投报，跳转建投的甘肃建投报 -->
                          <a
                            v-if="
                              !item1.child.length &&
                              item1.entTChannelUuid == '02310006'
                            "
                            href="http://www.gsjtw.cc/newsPaper/001900100004"
                            target="_blank"
                          >
                            {{ item1.name }}
                          </a>
                          <!-- 特殊情况，有三级，为大事记，跳大事记板块 -->
                          <!-- <a v-if="item1.child.length && item1.entTChannelUuid =='00190007'" -->
                          <a
                            v-if="
                              item1.child.length &&
                              item1.entTChannelUuid == '02320005'
                            "
                            href="/memorabilia/02320005"
                            target="_blank"
                          >
                            {{ item1.name }}
                          </a>
                          <!-- 测试memorabilia -->
                          <!-- <a v-if="!item1.child.length && item1.entTChannelUuid =='00190007'" -->
                          <a
                            v-if="
                              !item1.child.length &&
                              item1.entTChannelUuid == '02320005'
                            "
                            :href="`/memorabilia/${item1.entTChannelUuid}`"
                            target="_blank"
                          >
                            {{ item1.name }}
                          </a>
                          <!-- :href="`/list/${item1.entTChannelUuid}`" -->
                          <!-- :href="`/memorabilia/${item1.entTChannelUuid}`" -->
                          <!-- 有三级 -->
                          <!-- <a v-if="item1.child.length && (!item1.child[0].url || item1.child[0].url == ''|| item1.child[0].url == null ) && item1.entTChannelUuid !=='00190007'" -->
                          <a
                            v-if="
                              item1.child.length &&
                              (!item1.child[0].url ||
                                item1.child[0].url == '' ||
                                item1.child[0].url == null) &&
                              item1.entTChannelUuid !== '02320005'
                            "
                            :href="
                              item1.catalog === 1
                                ? `/listPage/${item1.child[0].entTChannelUuid}`
                                : item1.catalog === 2
                                ? `/list/${item1.child[0].entTChannelUuid}`
                                : `/list/${item1.child[0].entTChannelUuid}`
                            "
                            target="_blank"
                          >
                            {{ item1.name }}
                          </a>
                          <!--  <a v-if="item1.child.length && (!item1.child[0].url || item1.child[0].url == '') && item1.entTChannelUuid =='011500050003'"
                            :href="`/list/011500050003`"
                            target="_blank">
                            {{ item1.name }}
                          </a> -->
                        </p>
                      </div>
                    </div>
                  </el-collapse-transition>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- main -->
    <div class="mainBox containerMain" :style="containerStyle">
      <router-view></router-view>
    </div>
    <!-- footer -->
    <div class="footerBox">
      <div class="wrap">
        <el-row>
          <!-- 左栏 -->
          <el-col :xl="6" :lg="5" :md="24" :sm="24" :xs="15">
            <div class="footerL">
              <el-select
                v-model="value"
                @change="selectChange"
                placeholder="—友情链接—"
              >
                <el-option
                  v-for="item in options"
                  :key="item.index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <!-- <el-select
                v-model="value2"
                @change="selectChange2"
                placeholder="—行业链接—"
                style="margin-left: 4%"
                class="el-select2"
              >
                <el-option
                  v-for="item in options2"
                  :key="item.index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->
            </div>
          </el-col>
          <!-- 中栏 -->
          <el-col :xl="8" :lg="8" :md="10" :sm="9" :xs="24">
            <div class="footerM">
              <img src="../assets/image/wxewm.png" />
              <p>甘肃安装集团微信公众号</p>
            </div>
          </el-col>
          <!-- 右栏 -->
          <el-col :xl="10" :lg="11" :md="14" :sm="15" :xs="24">
            <div class="footerR">
              <p>Copyright © 甘肃省安装建设集团有限公司 版权所有</p>
              <p>地址：甘肃省兰州市七里河区吴家园西街2号</p>
              <p class="fl">
                <a
                  href="https://beian.miit.gov.cn/#/Integrated/index"
                  target="_blank"
                  style="color: #fff"
                  >陇ICP备15001032号-1&nbsp;</a
                >
              </p>
              <p class="fl">
                <a
                  href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62010302000331"
                  target="_blank"
                  style="color: #fff"
                  >甘公网安备 62010302000331号
                </a>
              </p>
              <p class="fl" style="clear: both">电话：0931-2341180</p>
              <p class="fl p6">技术支持：建投智能</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { getNavChannel, getAdvert } from "@/api/common";
export default {
  name: "",
  data() {
    return {
      activeNav: 0,
      navSubList: [],
      containerStyle: {},
      viewImgTop: true,
      content: "",
      viewSearch: false,
      searchValue: "",
      logo: require("@/assets/img/logo_lj.jpg"),
      // logo2: require("@/assets/img/logo2.png"),
      active: 0,
      navList: [],
      navDown: 0,
      // NEW
      value: "—友情链接—",
      value2: "—行业链接—",
      options: [
        {
          value: "http://www.gsjtw.cc/",
          label: "甘肃建投",
        },
        // {
        //   value: "http://www.gsyj.com.cn",
        //   label: "一建集团",
        // },
        // {
        //   value: "http://www.gsejjt.com.cn",
        //   label: "二建集团",
        // },
        // {
        //   value: "http://www.gssanjian.com",
        //   label: "三建集团",
        // },
        // {
        //   value: "http://www.gssjjt.com",
        //   label: "四建集团",
        // },
        // {
        //   value: "http://www.gs5j.com",
        //   label: "五建集团",
        // },
        // {
        //   value: "http://www.gsljw.com",
        //   label: "六建集团",
        // },
        // {
        //   value: "http://www.gs7j.com.cn",
        //   label: "七建集团",
        // },
        // {
        //   value: "http://www.gs8j.com",
        //   label: "八建集团",
        // },
        // {
        //   value: "http://www.gs9j.com",
        //   label: "九建集团",
        // },
        // {
        //   value: "http://www.gsya.com.cn",
        //   label: "一安公司",
        // },
        // {
        //   value: "http://www.gsjtsd.com",
        //   label: "隧道工程公司",
        // },
        // {
        //   value: "http://www.gsjky.com.cn",
        //   label: "建筑科学研究院",
        // },
        // {
        //   value: "http://www.gjtsst.com",
        //   label: "天水混凝土公司",
        // },
        // {
        //   value: "http://www.gcigcem.com.cn/",
        //   label: "装备制造有限公司",
        // },
        // {
        //   value: "http://www.gsjtzcb.com",
        //   label: "甘肃建投建设有限公司",
        // },
        // {
        //   value: "http://www.cgicop.com",
        //   label: "中甘国际",
        // },
        // {
        //   value: "http://www.gsjtst.com/",
        //   label: "商品混凝土公司",
        // },
        // {
        //   value: "http://www.gcctravel.com",
        //   label: "国际旅行社",
        // },
        // {
        //   value: "http://www.gsjtpxzx.com",
        //   label: "甘肃建投培训中心",
        // },
      ],
      options2: [
        {
          value: "http://inco.cscec.co",
          label: "中建安装工程有限公司",
        },
        // {
        //   value: 'http://www.gsjtst.com/',
        //   label: '陕西建工安装集团有限公司'
        // },
        {
          value: "http://www.siec.cn",
          label: "上海市安装工程集团有限公司",
        },
        {
          value: "http://www.scic.cn",
          label: "四川省工业设备安装公司",
        },
        {
          value: "http://www.siec.cn",
          label: "上海市安装工程集团有限公司",
        },
        {
          value: "http://www.scic.cn",
          label: "四川省工业设备安装公司",
        },
        {
          value: "http://www.ycijc.com",
          label: "云南建工安装有限公司",
        },
        {
          value: "http://www.huashi.sc.cn",
          label: "四川华西集团有限公司",
        },
        {
          value: "http://www.shxi-jz.com",
          label: "陕西建工集团网",
        },
      ],
    };
  },
  mounted() {
    this.getPath();
    this.getNavChannel();
    this.active = this.$route.params.id;
    let url = this.$route.name;
    if (url == "home") {
      this.srollimg();
    }
    this.srollChannelTop();
  },
  created() {},
  watch: {
    $route: "getPath",
  },
  methods: {
    searchSubmit() {
      var _this = this;
      if (!_this.searchValue || _this.searchValue == "") {
        this.$message({
          message: "请输入关键词进行搜索！",
          type: "warning",
          offset: 200,
        });
      } else {
        window.location.href = `/search/${_this.searchValue}`;
        // window.open(`/search/${_this.searchValue}`)
      }
    },
    srollimg() {
      var _this = this;
      let data = {
        applicationUuid: _this.webId,
        advertType: 4,
      };
      getAdvert(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          data.length && (_this.content = data[0]);
          this.$nextTick(() => {
            // this.srollTop()
          });
        }
      });
    },

    srollChannelTop() {
      var _this = this;
      let url = this.$route.name;
      if (url == "home") {
        setTimeout(() => {
          _this.activeNav = 1;
        }, 4000);
      } else {
        _this.activeNav = 1;
      }
    },
    searchBtn(val) {
      var _this = this;
      _this.viewSearch = val;
    },
    // 获取导航
    getNavChannel() {
      var _this = this;
      let data = {
        applicationUuid: _this.webId,
        // applicationUuid: _this.webIdGroup
      };
      getNavChannel(data).then((res) => {
        const { code, data } = res;
        if (code === 1 && data) {
          _this.navList = data.slice(0, 8);
          // console.log(123456nav,_this.navList)
        }
      });
    },
    // 二级导航展开
    navShow(d) {
      let _this = this;
      // _this[d] = true
      _this.navDown = d;
    },
    // 二级导航收起
    navClose() {
      let _this = this;
      // _this[d] = false
      _this.navDown = 0;
    },
    haddleNav(index, params) {
      var _this = this;

      _this.active = index;
      _this.$router.push(params.url);
    },
    getPath() {
      var _this = this;
      _this.active = _this.$route.meta.index;
    },
    // 友情链接
    selectChange(value) {
      console.log(value), window.open(this.value);
    },
    selectChange2(value2) {
      console.log(value2), window.open(this.value2);
    },
  },
};
</script>
<style>
#topPart,
.top {
  /* display: none; */
  width: 100%;
  height: auto;
}
.topLogoMain {
  width: 1300px;
  height: auto;
  overflow: hidden;
  margin: 0 auto;
}
.topLogoMainLeft {
  width: 50%;
  height: 100px;
  text-align: center;
  float: left;
  /* float: right !important; */
}
.topLogoMainLeft img {
  height: 100%;
}
.topLogoMainRight {
  width: 50%;
  height: 100px;
  float: right;
}
.header_search {
  width: 80%;
  float: right;
  margin-top: 30px;
}
.header_search div {
  height: 40px;
  font-size: 14px;
}
.header_search input {
  overflow: hidden;
  line-height: 40px;
  color: #585858;
  border-radius: 0px;
  border: solid 1px #0d65af;
}
.header_search button {
  height: 40px;
  line-height: 40px;
  padding: 0px 12px;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  border: none;
  cursor: pointer;
  /* vertical-align: top; */
  width: 52px;
  background-color: #0d65af;
  border-radius: 0px;
}
.header_search .el-button:hover {
  color: black;
  background-color: rgb(13, 101, 175);
}
.header_search .el-button:focus {
  color: rgb(255, 255, 255);
  border-color: #c6e2ff;
  background-color: rgb(54, 154, 236);
}
/* 导航菜单 */
.topMenu {
  width: 100%;
  height: auto;
  overflow: hidden;
  border-bottom: 1px #ffffff solid;
}
.nav_box {
  /* width: 1300px; */
  margin: 0 auto;
  height: auto;
  white-space: nowrap;
}
.nav_box_list {
  width: 70%;
  margin: 0 auto;
  white-space: nowrap;
  overflow-x: scroll;
}
.nav_box_list::-webkit-scrollbar {
  display: none;
}
.nav_box_list li {
  /* float: left; */
  display: inline-block;
  height: 40px;
  width: 14%;
  line-height: 40px;
  text-align: center;
}
.nav_box_list li h2 a {
  display: block;
  font-size: 16px;
  position: relative;
}
.nav_box_list li:hover h2 a {
  color: #fff;
  background-color: rgba(2, 99, 180);
}
/* .nav_box_list li h2 a::before {
  display: block;
  content: "";
  position: absolute;
  width: 0;
  height: 3px;
  background-color: #0062b1;
  left: 50%;
  bottom: 15px;
  margin-left: 0;
  -moz-transition: all 0.3s ease-in;
  -webkit-transition: all 0.3s ease-in;
  -o-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}
.nav_box_list li:hover h2 a::before {
  width: 50px;
  margin-left: -25px;
} */
.nav_down {
  position: absolute;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  color: #fff;
  left: 0;
  top: 140px;
  text-align: center;
  z-index: 100;
}
.nav_down_wrap {
  padding: 10px 0;
}
.nav_down a {
  color: #fff;
  font-size: 16px;
  margin: 0 20px;
}
.nav_down a:hover {
  font-weight: bold;
}
.nav_down p {
  display: inline-block;
}

.form-control {
  display: block;
  padding: 6px 12px;
}
.containerMain {
  -moz-transition: all 1s ease-in;
  -webkit-transition: all 1s ease-in;
  -o-transition: all 1s ease-in;
  transition: all 1s ease-in;
  z-index: 10;
  background-color: #fff;
}
.el-menu-item {
  width: 148px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  float: left;
  color: #ffffff;
  display: block;
  font-size: 16px;
  font-weight: 600;
}
.el-menu-item2 {
  width: 148px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  float: left;
  color: #ffffff;
  display: block;
  font-size: 16px;
  font-weight: 600;
}
.el-menu-item:hover {
  background-color: rgba(7, 6, 63, 0.425) !important;
}
.el-menu--horizontal > .el-menu-item {
  float: left;
  height: 60px;
  line-height: 52px;
  margin: 0;
  border-bottom: 2px solid transparent;
}
.el-menu .span1 {
  width: 2px;
  height: 50px;
  background: url(../assets/image/menu_line.jpg) center center no-repeat;
  display: inline-block;
}
.el-menu .span2 {
  width: 2px;
  height: 50px;
  display: inline-block;
}
.footerBox {
  padding: 60px 0 40px;
  background-color: #0062b1;
  color: #fff;
  font-size: 16px;
}
.footerL {
  margin-top: 85px;
}
.footerL .el-select {
  /* background-color: rgb(231, 255, 184); */
  float: left;
  width: 100%;
}
.footerL .el-input__inner {
  background: none;
  border: 1px solid #9194a7;
  color: #ffffff;
  line-height: 30px;
  font-size: 13px;
  width: 100%;
  /* background-color: rgb(194, 255, 171); */
  height: 30px;
  border-radius: 0px;
}
/* 小箭头 */
.el-input__suffix {
  position: absolute;
  top: 4px;
  height: 100%;
  color: #ffffff;
  text-align: center;
}
.el-select-dropdown {
  border: 1px solid #e4e7ed;
  border-radius: 1px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  box-sizing: border-box;
  margin: 5px 0;
}
.el-select-dropdown__item {
  font-size: 12px;
  padding: 0 20px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #222;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
  cursor: pointer;
}
.el-select-dropdown__item.selected {
  color: #fff;
  background-color: rgb(30, 144, 255);
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: rgb(30, 144, 255);
  color: #fff;
}
.el-select .el-input .el-select__caret {
  color: #ffffff;
}
/* 下中 */
.footerM {
  /* background-color: rgb(41, 255, 30); */
  text-align: center;
  width: 100%;
  margin-top: 5px;
}
.footerM img {
  width: 40%;
}
.footerM p {
  padding-top: 15px;
}
/* 下右 */
.footerR p {
  /* background-color: rgb(255, 172, 227); */
  margin-bottom: 6%;
}
.footerR .p6 {
  /* background-color: rgb(255, 172, 227); */
  margin-left: 50px;
}

@media (max-width: 1366px) {
  .topHeaderMain,
  .topLogoMain {
    width: 1000px;
  }
  .header_search .el-input {
    width: 80% !important;
  }
  .header_search {
    margin-top: 35px;
  }
  .nav_box_list {
    width: 90%;
  }
  /* .el-menu-item {
    width: 120px;
  }
  .el-menu-item2 {
    width: 120px;
  } */
}
@media (max-width: 1200px) {
  .footerL {
    margin-top: 0px;
  }
  .footerL .el-select {
    width: 100%;
  }
  .footerL .el-select.el-select2 {
    margin-left: 5% !important;
  }
  .footerM {
    margin-top: 40px;
  }
  .footerR {
    margin-top: 25px;
  }
  .footerM img {
    width: 26%;
  }
}
@media (max-width: 992px) {
  .topHeaderMain,
  .topLogoMain {
    width: 90%;
  }
  .footerL .el-select {
    width: 100%;
  }
  .footerL .el-select.el-select2 {
    margin-left: 5% !important;
  }
  /* #topPart{
    display: block;
    background-color: #fff;
  }
  .topImg{
    display: none;
  }
  .nav_box {
     padding-top: 0px; 
  }
  .nav_box_list {
    text-align: center;
    width: auto;
    margin: 0 auto;
  }
  .topHeaderMain,
  .topLogoMain {
    width: 94%;
  }
  .topLogoMainLeft {
    width: 50%;
  }
  .topLogoMainRight {
    width: 46%;
  }
  .header_search {
    width: 100%;
  }
  .header_search .el-input {
    width: 80% !important;
  }
  .header_search input {
    width: 100%;
  }
  .el-menu-item {
    width: 100px;
    padding-left: 0;
    padding-right: 0;
  }
  .el-menu-item2 {
    width: 100px;
    padding-left: 0;
    padding-right: 0;
  }
  .el-menu .span1,
  .el-menu .span2 {
    display: none;
  } */
}
@media (max-width: 768px) {
  .topLogoMainLeft,
  .topLogoMainRight {
    width: 100%;
    height: auto;
  }
  .topLogoMainLeft {
    height: 60px;
  }
  .topLogoMainLeft img {
    height: 100%;
  }
  .header_search {
    width: 95%;
    margin-top: 0px;
  }
  .footerL {
    width: 90%;
    margin-left: 35%;
  }
  .footerR {
    margin-left: 10%;
  }
  .footerR .p6 {
    margin-left: 9px;
  }
  .nav_box {
    width: 100%;
  }
  .nav_box_list li {
    width: 80px;
  }
  /* .nav_box {
    white-space: nowrap !important;
  }
  .nav_box_list li {
    width: 80px;
  }
  .nav_box_list {
    overflow-x: auto !important;
    white-space: nowrap !important; */
  /* white-space: nowrap;
    overflow-x: scroll;
    overflow-y: hidden; */
  /* } */

  /* #topPart{
    display: block;
    background-color: #fff;
    }
    .topImg{
    display: none;
    }
  .topwrap{
    margin: 0 auto;
    width: auto;
  }
  .header_search {
    width: 100%;
  }
  .header_search .el-input {
    width: 80% !important;
    height: 38px;
    line-height: 38px;
  }
  .header_search input {
    width: 100%;
  }
  .nav_down{
    display: none;
  }
  .nav_box_list li {
    float: left;
    line-height: 50px;
    margin: 0 13px;
  }
  .nav_box {
    padding-top: 0px;
    width: 100%;
    height: 50px;
    text-align: center;
    width: 100%;
    white-space: nowrap;
    overflow-y: hidden;
    overflow-x: auto;
  }
  .nav_box_list {
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
    border-bottom: none;
    padding: 0;
    height: 50px;
  }
  .footerBox{
    width: auto;
    margin: 0 auto;
    padding: 10px 0 10px;
  }
  .containerMain{
    margin-top: auto;
  }
  .topLogoMainLeft {
    width: 100%;
    text-align: center;
  }
  .topLogoMainLeft img {
    width: 90%;
  }
  .topLogoMainRight {
    width: 100%;
    margin-top: 0;
  }
  .header_search .el-input {
    width: calc(100% - 54px) !important;
  }
  .el-menu.el-menu--horizontal {
    width: auto;
    overflow-x: auto;
    white-space: nowrap;
    border-bottom: none;
    padding: 0;
    height: 50px;
  }
  .el-menu .span1,
  .el-menu .span2 {
    display: none;
  }
  .logoImgPc {
    display: none;
  }
  .topLogoMainLeft a {
    display: block;
  } */
}
</style>
